import { useEffect } from "react";
import useGlobalStore from "../store/store";
import useAdminDataStore, { selectCurrentGroupData } from "../store/adminData/adminData";
import { fbGetFormLayout } from "../services/firebaseService/endPoints/admin/members";

const useFormLayout = () => {
  const { formLayout, setFormLayout, formLayoutLoading, setFormLayoutLoading } =
    useGlobalStore.getState().formLayout;

  const { setShowAddMember } = useGlobalStore.getState().members;

  const groupData = useAdminDataStore(selectCurrentGroupData);

  const fetchFormLayout = async (groupId) => {
    try {
      setFormLayoutLoading(true);
      const data = await fbGetFormLayout(groupId);
      setFormLayout(groupId, data);
      if (data) {
        setShowAddMember(true);
      }
    } catch (error) {
      setFormLayout(groupId, {});
    } finally {
      setFormLayoutLoading(false);
    }
  };

  useEffect(() => {
    if (!formLayout?.[groupData?.id]) {
      fetchFormLayout(groupData?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  return {
    formLayout: formLayout?.[groupData?.id] || {},
    formLayoutLoading,
    fetchFormLayout,
  };
};

export default useFormLayout;
